import { textMdSemibold } from '@insify/design-system/typography';
import clsx from 'clsx';

import * as styles from './USPs.module.css';

import type React from 'react';

type Props = {
  className?: string;
  usps: { icon: React.ReactNode; text: string; highlighted?: boolean }[];
};

export const USPs = ({ className, usps }: Props) => (
  <ul className={clsx(styles.list, className)}>
    {usps.map(({ icon, text, highlighted }) => (
      <li key={text} className={clsx(textMdSemibold, styles.item, highlighted && styles.highlighted)}>
        {icon}
        {text}
      </li>
    ))}
  </ul>
);
